import React, { useState, useRef, useEffect } from "react";
import { Globe, ChevronDown } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

const LanguageSelector = () => {
  const { language, changeLanguage, translate } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const languages = [
    { code: "en", label: "EN", name: translate("english") },
    { code: "pt", label: "PT", name: translate("portuguese") },
  ];

  const currentLanguage = languages.find((lang) => lang.code === language);

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="hover-surface flex items-center space-x-2 px-3 py-2 text-sm font-medium rounded-lg transition-colors"
        style={{ color: "var(--color-text-secondary)" }}
      >
        <Globe size={16} />
        <span>{currentLanguage?.label}</span>
        <ChevronDown
          size={14}
          className={`transition-transform ${isOpen ? "rotate-180" : ""}`}
        />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 border border-[var(--color-border)] rounded-xl shadow-lg z-50" style={{ backgroundColor: "var(--color-surface)" }}>
          <div className="py-1">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => handleLanguageChange(lang.code)}
                className={`w-full text-left px-4 py-2 text-sm transition-colors flex items-center space-x-2 ${
                  language === lang.code
                    ? "bg-[var(--color-mint-muted)] text-[var(--color-mint)]"
                    : "hover:bg-[var(--color-mint-muted)] hover:text-[var(--color-mint)]"
                }`}
                style={language !== lang.code ? { color: "var(--color-text-primary)" } : undefined}
              >
                <span className="font-medium">{lang.label}</span>
                <span>{lang.name}</span>
                {language === lang.code && (
                  <div className="ml-auto w-2 h-2 bg-[var(--color-mint)] rounded-full"></div>
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
